/* ─────────────────────────────────────────────────────────────
   Darussalam UK — Start a Return popup
   assets/return-popup.js
   ───────────────────────────────────────────────────────────── */

(function () {
  "use strict";

  // Guard: prevent multiple init if script loads more than once
  if (window.__dsReturnPopupInit) return;
  window.__dsReturnPopupInit = true;

  const POPUP_ID = "ds-return-popup";
  const popup = document.getElementById(POPUP_ID);
  if (!popup) return;

  const shell = popup.querySelector(".ds-pop-shell");
  const form = popup.querySelector("#ds-return-form");
  const submitBtn = popup.querySelector("[data-ds-submit]");
  const submitLabel = popup.querySelector("[data-ds-submit] [data-label]");
  const successScreen = popup.querySelector("[data-ds-success-screen]");

  // ── Open / close ─────────────────────────────────────
  function openPopup() {
    popup.style.display = '';
    popup.setAttribute("aria-hidden", "false");
    document.body.classList.add("ds-pop-locked");
    // focus first field
    const firstInput = popup.querySelector("input, select");
    setTimeout(() => firstInput && firstInput.focus(), 200);
  }

  function closePopup() {
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ds-pop-locked");
  }

  document.addEventListener("click", function (e) {
    const opener = e.target.closest("[data-ds-return-open]");
    if (opener) { e.preventDefault(); openPopup(); return; }

    const closer = e.target.closest("[data-ds-return-close]");
    if (closer) { e.preventDefault(); closePopup(); return; }

    // click on overlay (outside shell)
    if (e.target === popup) { closePopup(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.getAttribute("aria-hidden") === "false") {
      closePopup();
    }
  });

  // ── Validation ───────────────────────────────────────
  const validators = {
    name(v) {
      if (!v.trim()) return { state: "idle" };
      if (v.trim().length < 2) return { state: "err", msg: "Please enter your full name" };
      if (!/^[a-zA-Z\u0600-\u06FF\s'.-]+$/.test(v.trim())) return { state: "err", msg: "Letters only please" };
      return { state: "ok", msg: "Looks good" };
    },
    email(v) {
      if (!v.trim()) return { state: "idle" };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())) return { state: "err", msg: "Enter a valid email" };
      return { state: "ok", msg: "We'll send confirmation here" };
    },
    order(v) {
      if (!v.trim()) return { state: "idle" };
      if (!/^#?[A-Za-z0-9-]{4,}$/.test(v.trim())) return { state: "err", msg: "Order # looks like #DSL12345" };
      return { state: "ok", msg: "Order # accepted" };
    },
    tracking(v) {
      if (!v.trim()) return { state: "idle" };
      if (v.trim().length < 6) return { state: "err", msg: "Tracking numbers are usually 6+ characters" };
      return { state: "ok", msg: "Tracking number accepted" };
    },
    reason(v) {
      if (!v) return { state: "idle" };
      return { state: "ok" };
    }
  };

  function applyValidation(field) {
    const kind = field.dataset.validate;
    if (!kind || !validators[kind]) return { state: "idle" };
    const result = validators[kind](field.value);
    const wrap = field.closest(".ds-popA-field");
    const hint = wrap ? wrap.querySelector("[data-hint]") : null;

    field.classList.remove("ok", "err");
    if (field.dataset.touched === "true" && result.state !== "idle") {
      field.classList.add(result.state);
    }
    if (hint) {
      hint.classList.remove("ok", "err");
      if (field.dataset.touched === "true" && result.state !== "idle" && result.msg) {
        hint.classList.add(result.state);
        hint.textContent = (result.state === "ok" ? "✓ " : "⚠ ") + result.msg;
      } else {
        hint.textContent = "";
      }
    }
    return result;
  }

  function isFormValid() {
    const fields = form.querySelectorAll("[data-validate]");
    let ok = true;
    fields.forEach(f => {
      const r = validators[f.dataset.validate](f.value);
      if (r.state !== "ok") ok = false;
    });
    return ok;
  }

  function refreshSubmitState() {
    if (submitBtn) submitBtn.disabled = !isFormValid();
  }

  if (form) {
    form.querySelectorAll("[data-validate]").forEach(field => {
      field.addEventListener("input", () => {
        if (field.dataset.touched === "true") applyValidation(field);
        refreshSubmitState();
      });
      field.addEventListener("blur", () => {
        field.dataset.touched = "true";
        applyValidation(field);
        refreshSubmitState();
      });
      field.addEventListener("change", () => {
        field.dataset.touched = "true";
        applyValidation(field);
        refreshSubmitState();
      });
    });

// Submit handler — posts to Web3Forms (JSON)
form.addEventListener("submit", function (e) {
  e.preventDefault();

  // mark all touched & validate
  form.querySelectorAll("[data-validate]").forEach(f => { f.dataset.touched = "true"; applyValidation(f); });
  if (!isFormValid()) return;

  submitBtn.disabled = true;
  if (submitLabel) submitLabel.textContent = "Submitting…";

  const formData = new FormData(form);
  const payload = Object.fromEntries(formData);

  fetch(form.action, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then(json => {
    if (json.success) {
      showSuccess();
    } else {
      alert("Something went wrong: " + (json.message || "Please try again."));
      submitBtn.disabled = false;
      if (submitLabel) submitLabel.textContent = "Submit Return";
    }
  })
  .catch(() => {
    alert("Network error. Please check your connection and try again.");
    submitBtn.disabled = false;
    if (submitLabel) submitLabel.textContent = "Submit Return";
  });
});
  }

  // ── Success screen ───────────────────────────────────
function showSuccess() {
  const name = (form.querySelector("[name='name']") || {}).value || "";
  const email = (form.querySelector("[name='email']") || {}).value || "";
    const ref = "RET-" + Math.floor(100000 + Math.random() * 900000);

    const nameEl  = popup.querySelector("[data-success-name]");
    const emailEl = popup.querySelector("[data-success-email]");
    const refEl   = popup.querySelector("[data-success-ref]");
    if (nameEl)  nameEl.textContent  = (name.split(" ")[0] || "friend");
    if (emailEl) emailEl.textContent = email || "your inbox";
    if (refEl)   refEl.textContent   = ref;

    if (successScreen) successScreen.dataset.show = "true";
    if (shell) shell.dataset.state = "success";
  }

  // If Shopify reloads the page after a successful native form post (form.posted_successfully?),
  // the snippet pre-renders data-show="true" — auto-open the popup so the user sees confirmation.
  if (successScreen && successScreen.dataset.show === "true") {
    if (shell) shell.dataset.state = "success";
    openPopup();
  }
})();
